import { AfterViewInit, Component, OnInit, Output, Input, ElementRef, EventEmitter, ViewChild} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginService, UsuarioService, CidadeService } from '../../../services/';
import { FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { Usuario } from '../../../model';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { API } from '../../../app.config';
import * as moment from 'moment';

const { cpf } = require('cpf-cnpj-validator');

import SignaturePad from 'signature_pad';

@Component({
  selector: 'senha-form',
  templateUrl: './senha-form.component.html',
  styleUrls: ['./senha-form.component.scss']
})
export class SenhaFormComponent implements OnInit, AfterViewInit {

  @ViewChild('sPad') signaturePadElement?: ElementRef;
  signaturePad: any;


  private sPad: ElementRef;

  @ViewChild('sPad') set content(content: ElementRef) {
    if (content) {
      this.sPad = content;
      this.signaturePad = new SignaturePad(this.sPad.nativeElement);
    }
  }

  ngAfterViewInit(): void {
    if(this.signaturePadElement != undefined && this.signaturePadElement.nativeElement != undefined){
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
    }
  }

  @Input()
  alteracaoObrigatoria: Boolean = true;

  @Output()
  alterou = new EventEmitter<any>();

  senhaAtual: string;
  senha: string;
  resenha: string;
  alterada = false;
  loadingAlterarSenha = false;
  sucessoAlterarSenha = false;
  loadingAlterarDados = false;
  sucessoAlterarDados = false;
  erroAlterarSenha = '';
  erroAlterarDados = '';
  public MASKS = MASKS;
  data: [];

  usuario: any;
  form: FormGroup;
  mensagensErro = [];

  Api = API;

  constructor(
    private loginService: LoginService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private cidadeService: CidadeService,
    private modalService: NgbModal ) {

      this.usuario = this.loginService.user();

      this.usuario.DataNascimento = this.usuario.DataNascimento != null ? moment(this.usuario.DataNascimento) : this.usuario.DataNascimento;
    }

  ngOnInit() {
    this.form = this.formBuilder.group({
      SenhaAtual: this.formBuilder.control('', [Validators.required,Validators.minLength(6) ,Validators.maxLength(20)]),
      Senha: this.formBuilder.control('', [Validators.required,Validators.minLength(6) ,Validators.maxLength(20)]),
      Resenha: this.formBuilder.control('', [Validators.required,Validators.minLength(6) ,Validators.maxLength(20)]),
      Nome: this.formBuilder.control("", [Validators.required, Validators.minLength(4),]),
      Sobrenome: this.formBuilder.control(""),
      Email: this.formBuilder.control("", [Validators.required,Validators.email,]),
      Telefone: this.formBuilder.control(""),
      DataNascimento: this.formBuilder.control(""),
      CidadeId: this.formBuilder.control("", [Validators.required]),
      Rg: this.formBuilder.control(""),
      CPF: this.formBuilder.control("", [Validators.required]),
    });

    if (!this.usuario.AtualizarDados) {
      this.form.get('Nome').setValidators(null);
      this.form.get('Email').setValidators(null);
      this.form.get('CidadeId').setValidators(null);
      this.form.get('Rg').setValidators(null);
      this.form.get('CPF').setValidators(null);
    }

   }

  alterarSenha(){
    this.erroAlterarSenha = '';
    this.sucessoAlterarSenha = false;
    this.loadingAlterarSenha = true;

    if (this.senha != this.resenha)
    {
      this.erroAlterarSenha = 'As senhas digitadas não conferem';
      this.loadingAlterarSenha = false;
    }
    else
    {
      this.usuarioService.alterarSenha(this.usuario.Id, this.senha, this.senhaAtual).subscribe(
        dados => {

          this.sucessoAlterarSenha = true;
          this.loadingAlterarSenha = false;
          this.alteracaoObrigatoria = false;
          // this.senha = '';
          // this.resenha = '';
          // this.senhaAtual = '';

          this.alterada = true;
          this.form.markAsPristine();

          if (this.usuario.AtualizarDados){
            this.salvar();
          }
        },
        erro => {
          this.loadingAlterarSenha = false;
          console.log(erro);
          if (erro.status == 400){
            this.erroAlterarSenha = erro.error.mensagem;
          }else if (erro.status = 406){
            this.erroAlterarSenha = erro.error.mensagens[0];
          }
          else{
            this.erroAlterarSenha = 'Erro ao alterar a senha, tente novamente mais tarde!';
          }
          console.log(erro);
        });
      }
    }

 salvar() {
   this.erroAlterarDados = '';
   this.sucessoAlterarDados = false;
   this.loadingAlterarDados = true;

   this.usuario.TrocarSenha = false;
   this.usuario.AtualizarDados = false;

    this.usuarioService.salvarDados(this.usuario).subscribe(
      (dados) => {

        this.sucessoAlterarDados = true;
        this.loadingAlterarDados = false;

      },
      (erros) => {
        this.loadingAlterarDados = false;
        this.usuario.TrocarSenha = true;
        this.usuario.AtualizarDados = true;

        if (erros.status == 400){
          this.erroAlterarDados = erros.error.mensagem;
        }else if (erros.status = 406){
          this.erroAlterarDados = erros.error.mensagens[0];
        }
        else{
          this.erroAlterarDados = 'Erro ao alterar a senha, tente novamente mais tarde!';
        }
        console.log("Erro ao Salvar");
        console.log(erros);
      }
    );
  }


  selecionaCidade(item) {
    this.usuario.Cidade = item;
  }

  onChangeCidade(val: string) {
    this.cidadeService.buscarPorParametro(val, 1).subscribe(
      (dados) => {
        this.data = dados.Items.map(function (x) {
          x.display_field =
            x.Nome + " / " + x.Estado.Nome + " - " + x.Estado.Pais.Nome;
          return x;
        });
      },
      (erro) => {
        console.log(erro);
        this.data = [];
      }
    );
  }

  fecharModal() {
    if(this.alterada){
      this.alterou.emit(true);
    }
    this.modalService.dismissAll();
  }

  savePNG() {
    if (this.signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const dataURL = this.signaturePad.toDataURL();
      this.uploadAssinatura(dataURL);
    }
  }

  uploadAssinatura(imagem) {
    this.usuarioService.uploadAssinatura(imagem, this.usuario.Id).subscribe(
      (dados) => {

        this.usuario.AssinaturaDigitalizada = "/uploads/usuario/" + dados;
      },
      (erros) => {
        console.log("Erro ao subir logo da agência");
        console.log(erros);
      }
    );
  }

  limpar() {
    this.signaturePad.clear();
  }

}
